import { getApp, getApps, initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyDF4KkWzSNH9BbFH46aTPBBoHSqfZFMGRo",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    "event-management-7fda1.firebaseapp.com",
  projectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID || "event-management-7fda1",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "event-management-7fda1.firebasestorage.app",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "254136311635",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    "1:254136311635:web:7c88f001771e3e8f2c8ba6",
};

const firebaseApp = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

/**
 * Requests browser notification permission and returns FCM token.
 * Returns empty string when unsupported, denied, or token generation fails.
 */
export const requestFcmToken = async () => {
  try {
    if (typeof window === "undefined") return "";
    if (!("Notification" in window) || !("serviceWorker" in navigator)) return "";

    const supported = await isSupported().catch(() => false);
    if (!supported) return "";

    const permission = await Notification.requestPermission();
    if (permission !== "granted") return "";

    const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
    if (!vapidKey) {
      console.warn(
        "Missing REACT_APP_FIREBASE_VAPID_KEY. Attempting FCM token without explicit VAPID key."
      );
    }

    const serviceWorkerRegistration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );
    const messaging = getMessaging(firebaseApp);
    const token = await getToken(
      messaging,
      vapidKey
        ? { vapidKey, serviceWorkerRegistration }
        : { serviceWorkerRegistration }
    );
    return token || "";
  } catch (error) {
    console.error("Failed to generate FCM token", error);
    return "";
  }
};

/**
 * Subscribes to foreground FCM notifications.
 * Returns an unsubscribe function.
 */
export const listenForForegroundMessages = async (onPayload) => {
  try {
    if (typeof window === "undefined") return () => {};
    if (!("Notification" in window)) return () => {};

    const supported = await isSupported().catch(() => false);
    if (!supported) return () => {};

    const messaging = getMessaging(firebaseApp);
    const unsubscribe = onMessage(messaging, (payload) => {
      const title =
        payload?.notification?.title || payload?.data?.title || "Event Management";
      const body = payload?.notification?.body || payload?.data?.body || "";
      const icon = payload?.notification?.icon || "/images/notification.svg";

      // Foreground FCM messages do not auto-show a system notification.
      if (Notification.permission === "granted") {
        try {
          new Notification(title, { body, icon });
        } catch (error) {
          console.warn("Could not show browser notification for foreground message.", error);
        }
      }

      if (typeof onPayload === "function") onPayload(payload);
    });

    return typeof unsubscribe === "function" ? unsubscribe : () => {};
  } catch (error) {
    console.error("Failed to subscribe to foreground FCM messages", error);
    return () => {};
  }
};

